import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useComponentNode from '../_COMPONENT/useComponentNode.jsx'
import meta from './metaWf.mjs'
import Model from './ModelWf.mjs'
import PropertiesPane from './PropertiesPaneWf.jsx'
import api from './apiWf.mjs'
import useContextMenu from './useContextMenuWf.mjs'

export default () => {
    const ComponentNode = useComponentNode()
    const contextMenu = useContextMenu()

    return extendNode(ComponentNode, {
        ...meta,
        api,
        contextMenu,
        // FormChoose,
        // TableChoose,
        Model,
        PropertiesPane,

        canMountType(map, node, type) {
            return /^(PIC)$/.test(type)
        },

        canWriteTree(map, node) {
            const {demoType} = node.data
            return 'IMG' === demoType
        },

        getStyle(map, node) {
            return {
                ...this._getStyle(map, node, {
                    backgroundColor: Color.LIGHT_BLUE,
                }),

                shape: 'Parallelogram',
            }
        },

        menuItemsInsertCommon(map, node) {
            const {demoType} = node.data

            if ('IMG' === demoType) {
                return [
                    {type: 'PIC'},
                ]
            }
            else {
                return []
            }
        },

        async _atCreate(map, node) {
            const n = map.createNode('PIC')
            map.appendChild(node, n)
            await ComponentNode._atCreate.call(this, map, node)
        },

        async _atOwnerPush(map, node, event) {
            const d = await this._getPushData(map, node)
            event.detail.wfList.push(d)
        },

        _getDefaultDataFields(map, node) {
            return {
                ...ComponentNode._getDefaultDataFields.call(this, map, node),
                demoType: 'IMG',
            }
        },

        async _pushDone(map, node, result) {
            await ComponentNode._pushDone.call(this, map, node, result)
            const {demoType, pkid} = result

            if ('DEMO' === demoType) {
                node.firstChild.data = {
                    ...node.firstChild.data,
                    fileId: pkid,
                }
            }
        },
    })
}
